import initial from 'lodash/initial';
import last from 'lodash/last';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function joinWithCommaAnd(array: Array<any> | Array<undefined> | undefined) {
  if (!Array.isArray(array)) {
    return '';
  }

  if (array.length < 2) {
    return array.join('');
  }
  return `${initial(array).join(', ')} and ${last(array)}`;
}
